let jquery = $;
const AjaxRequest = function(element, options) {
    let the = this;

    const _handlers = function () {
        $(the.element).on('click', function(event) {
            event.preventDefault();
            let $this = $(this);
            const url = $this.data('ajax');
            let method = 'GET';

            if (typeof 'undefined' !== $this.data('ajax-method')) {
                method = $this.data('ajax-method');
            }

            $.ajax({
                url: url,
                async: false,
                cache: false,
                processData: false,
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
                method: method,
                success: function() {
                    location.reload();
                },
                error: function(response) {
                    toastr.error(response.responseJSON.message);
                },
                always: function() {
                }
            })
        })
    }

    const _init = function() {
        the.uid = KUtil.getUniqueId('ajax-request');
        the.element = element;
        the.cropper = null;
        _handlers();

        KUtil.data(the.element).set('ajax-request', the);
    }

    const _construct = function() {
        if (true === KUtil.data(element).has('ajax-request')) {
            the = KUtil.data(element).get('ajax-request');
        } else {
            _init();
        }
    }

    _construct();
};

AjaxRequest.createInstances = function (selector) {
    const body = document.getElementsByTagName("BODY")[0];
    const elements = body.querySelectorAll(selector);

    if ( elements && elements.length > 0 ) {
        for (let i = 0, len = elements.length; i < len; i++) {
            new AjaxRequest(elements[i]);
        }
    }
}

AjaxRequest.init = function () {
    AjaxRequest.createInstances('[data-ajax]');
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', AjaxRequest.init);
} else {
    AjaxRequest.init();
}
